import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=44b046cd&scoped=true&"
import script from "./Contact.ts?vue&type=script&lang=ts&"
export * from "./Contact.ts?vue&type=script&lang=ts&"
import style0 from "./Contact.scss?vue&type=style&index=0&id=44b046cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b046cd",
  null
  
)

export default component.exports